<template>
  <a-layout style="min-height: 100vh">
    <a-layout-header
      prefixCls="ant-layout-header"
      class="header"
      :style="{ position: 'fixed', zIndex: 2, width: '100%', height: '44px' }"
    >
      <div class="logo">
        <img :src="logo" alt="logo" />
      </div>
      <top-navbar ref="topNavbar"></top-navbar>
    </a-layout-header>
    <a-layout-sider
      prefixCls="ant-layout-sider"
      width="200"
      :style="{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        marginTop: '44px',
      }"
    >
      <a-menu
        theme="dark"
        v-model:selectedKeys="currentRouteNames"
        mode="inline"
        style="padding-top: 12px"
      >
        <a-menu-item
          v-for="menu in menus"
          :key="menu.key"
          @click="({ item, key, keyPath }) => router(menu)"
        >
          <span>
            <component :is="menu.icon" />
            {{ menu.title }}</span
          >
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout
      prefixCls="ant-layout"
      :style="{ marginLeft: '200px', paddingTop: '40px' }"
    >
      <a-layout-content
        prefixCls="ant-layout-content"
        :style="{ background: '#fff' }"
      >
        <dashboard-content
          @changeTab="changeTab($event)"
          :routeLink="routeLink"
        ></dashboard-content>
      </a-layout-content>
      <a-layout-footer
        style="position: relative; padding: 8px; text-align: center"
      >
        Petrolimex
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
// import EventBus from "@/event-bus";
import {
  PieChartOutlined,
  DashboardOutlined,
  DesktopOutlined,
  UserOutlined,
  TeamOutlined,
  FileOutlined,
  ShoppingCartOutlined,
  MenuOutlined,
} from "@ant-design/icons-vue";

const ORDER_CUSTOMRE_ROUTE = "order-customer";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    PieChartOutlined,
    DesktopOutlined,
    UserOutlined,
    TeamOutlined,
    FileOutlined,
    DashboardOutlined,
    ShoppingCartOutlined,
    MenuOutlined,
  },
  data() {
    let currentRouteNames = [this.$route.path.replace("/", "")];
    let selectedKey = ["report"];
    return {
      selectedKey,
      currentRouteNames,
      routeLink: "",
      widthCollapse: "width : 200px",
      logo: "/petrolimex.png",
      logoCollapsed: "/petrolimex.png",
      collapsed: false,
      leftSideMenu: {
        position: "fixed",
        width: "200px",
        top: "42px",
        left: "0",
        bottom: "50px",
        height: "100%",
        marginBottom: "-70px",
        marginTop: 0,
        paddingBottom: "70px",
        zIndex: "10",
      },
      menus: [
        {
          key: "report",
          icon: DashboardOutlined,
          title: "Tổng quan",
          path: "report",
        },
        {
          key: "order-customer",
          icon: ShoppingCartOutlined,
          title: "Đơn hàng",
          path: "order-customer",
          status: "-2",
        },
        {
          key: "category",
          icon: MenuOutlined,
          title: "Địa chỉ",
          path: "location",
        },
      ],
      contentStyle: {
        backgroundColor: "#fff",
        marginRight: "0px",
        transition: "all 0.5s",
      },
    };
  },
  methods: {
    nextPage(value) {
      // EventBus.$emit('reloadPage')
      this.$router.push(value);
    },
    handleWidth(data) {
      if (data == "0px") {
        this.contentStyle.marginRight = "300px";
      } else {
        this.contentStyle.marginRight = "0";
      }
    },
    changeSider() {
      if (this.logo == require("@/assets/img/logo.png")) {
        this.logo = this.logoCollapsed;
        (this.widthCollapse = "width : 80px"),
          (this.contentStyle.marginLeft = "80px");
      } else {
        this.logo = "/petrolimex.png";
        (this.widthCollapse = "width : 200px"),
          (this.contentStyle.marginLeft = "200px");
      }
      this.collapsed = !this.collapsed;
      // EventBus.$emit('renderFullCalendar')
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    changeTab($event) {
      this.currentRouteNames = [ORDER_CUSTOMRE_ROUTE];
      this.$router.push({
        path: ORDER_CUSTOMRE_ROUTE,
        query: { status: $event },
      });
    },
    router(child) {
      if (child.path == ORDER_CUSTOMRE_ROUTE) {
        this.routeLink = child.status;
      }
      this.$router.push({ path: child.path, query: child.query });
    },
    reloadPage() {
      this.contentStyle.marginRight = "0";
    },
  },
  created() {
    // EventBus.$on('setWidthContent', this.handleWidth)
    // EventBus.$on('reloadPage', this.reloadPage)
  },
  destroyed() {
    // EventBus.$off('setWidthContent', this.handleWidth)
    // EventBus.off('reloadPage', this.reloadPage)
  },
};
</script>

<style lang="scss">
$primary-bg-color: #001529;
$primary-select-color: #1890ff;
$header-bg-color: #f1f5f9;
$header-text-color: #003b70;
$primary-color: #e1e1e1;
#components-layout-demo-side .logo {
  height: 32px;
  margin: 16px;
  background: rgba(255, 255, 255, 0.3);
}

.site-layout .site-layout-background {
  background: #fff;
}
[data-theme="dark"] .site-layout .site-layout-background {
  background: $primary-bg-color;
}

.ant-layout-header.header {
  background: $header-bg-color;
  border-bottom: 1px solid #d8e1ea;
  box-shadow: 0 3px 8px rgba(0, 21, 41, 0.16);
  box-sizing: border-box;
  height: 44px;
  padding: 0;
}

.logo {
  width: 200px;
  height: 44px;
  padding: 0 16px;
  background: transparent;
  box-sizing: border-box;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  img {
    width: 168px;
    max-width: 100%;
    height: auto;
  }
  span {
    font-size: 20px;
    font-weight: 600;
    color: $primary-bg-color;
    margin-left: 8px;
  }
}

.simple-text {
  color: #fff;
}

ul.ant-menu.ant-menu-horizontal.ant-menu-root.ant-menu-light {
  display: flex;
  justify-content: flex-end;
}

.top-navbar-menu.ant-menu-horizontal {
  background: $header-bg-color;
}

.top-navbar-menu.ant-menu-horizontal > .ant-menu-item,
.top-navbar-menu.ant-menu-horizontal > .ant-menu-submenu {
  color: $header-text-color;
}

.top-navbar-menu.ant-menu-horizontal > .ant-menu-item:hover,
.top-navbar-menu.ant-menu-horizontal > .ant-menu-item-active,
.top-navbar-menu.ant-menu-horizontal > .ant-menu-item-selected {
  color: $primary-select-color;
  background: rgba(24, 144, 255, 0.08);
  border-bottom-color: $primary-select-color;
}

.ant-menu.ant-menu-dark .ant-menu-item-selected {
  background-color: #e35a2c;
}
</style>
